import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-overview',
  standalone: true,
  imports: [],
  templateUrl: './admin-overview.component.html',
  styleUrl: './admin-overview.component.css'
})
export class AdminOverviewComponent {

}
